import { USER_ROLES } from "@/consts";

const accessRoles = [USER_ROLES.REGION_MANAGER];

export default {
  path: "area-manager",
  component: (resolve) => require(["@/views/AreaManager/Index"], resolve),
  hidden: true,
  name: "AreaManagerIndex",
  meta: {},
  children: [
    {
      path: "dashboard",
      component: () =>
        import(
          /* webpackChunkName: "area-manager-dashboard" */ "@/views/AreaManager/Dashboard"
        ),
      name: "AreaManagerDashboard",
      meta: { title: "业绩数据", accessRoles, withTabbar: true },
    },
    {
      path: "stores",
      component: () =>
        import(
          /* webpackChunkName: "area-manager-dashboard" */ "@/views/AreaManager/Stores"
        ),
      name: "AreaManagerStores",
      meta: { title: "店铺管理", accessRoles, withTabbar: true },
    },
    {
      path: "orders",
      component: () =>
        import(
          /* webpackChunkName: "area-manager-dashboard" */ "@/views/AreaManager/Orders"
        ),
      name: "AreaManagerOrders",
      meta: { title: "全部订单", accessRoles, withTabbar: true },
    },
    {
      path: "my",
      component: () =>
        import(
          /* webpackChunkName: "area-manager-dashboard" */ "@/views/AreaManager/Mine"
        ),
      name: "AreaManagerMy",
      meta: { title: "我的", accessRoles, withTabbar: true },
    },
    {
      path: "store-detail",
      component: () =>
        import(
          /* webpackChunkName: "area-manager-dashboard" */ "@/views/AreaManager/StoreDetail"
        ),
      name: "AreaManagerStoreDetail",
      meta: { title: "店铺详情", accessRoles, withTabbar: false },
    },

  ],
};
